module.exports = "/_next/static/images/coins-line-33f660991d3196e9f3d3f64d215f9414.svg";